import { FC, useState } from "react";
import styled from "@emotion/styled";
import { Box, Button, Flex, Text, TextField } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";
import { isEmpty } from "lodash-es";

export const SmartViewsRootPage: FC = () => {
  const navigate = useNavigate();
  const [smartViewId, setSmartViewId] = useState("");

  const handleOpenSmartView = () => {
    const trimmed = smartViewId.trim();
    if (isEmpty(trimmed)) {
      return;
    }
    navigate(atlasRoutes.smartViewsView({ params: { smartViewId: trimmed } }).path);
  };

  return (
    <Flex direction="column" gap="5">
      <div>
        <h1>Smart Views</h1>
        <Text size="2" color="gray">
          Quick links for inspecting existing smart views or kicking off a fresh Heads Up run.
        </Text>
      </div>

      <Flex gap="4" wrap="wrap">
        <ActionCard>
          <Flex direction="column" gap="3">
            <Text size="3" weight="bold">
              Open Smart View
            </Text>
            <Text size="2" color="gray">
              Jump directly to a smart view detail page by pasting its UUID.
            </Text>
            <Flex gap="2" align="center">
              <StyledTextField
                placeholder="Smart view ID"
                value={smartViewId}
                onChange={event => setSmartViewId(event.target.value)}
              />
              <Button size="2" onClick={handleOpenSmartView} disabled={isEmpty(smartViewId.trim())}>
                Open
              </Button>
            </Flex>
          </Flex>
        </ActionCard>

        <ActionCard>
          <Flex direction="column" gap="3">
            <Text size="3" weight="bold">
              Generate Smart View
            </Text>
            <Text size="2" color="gray">
              Use our get-or-generate flow to create Heads Up output for a space account.
            </Text>
            <Flex gap="2">
              <Button
                size="2"
                onClick={() => navigate(atlasRoutes.smartViewsGetOrGenerate({}).path)}
              >
                Go to generator
              </Button>
            </Flex>
          </Flex>
        </ActionCard>
      </Flex>
    </Flex>
  );
};

const ActionCard = styled(Box)`
  background: var(--gray-2);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid var(--gray-4);
  min-width: 320px;
  flex: 1 1 360px;
`;

const StyledTextField = styled(TextField.Root)`
  min-width: 240px;
`;

export default SmartViewsRootPage;
